import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const SkipToContentLink = ({ target, text }) => (
  <a className="SkipToContentLink" href={'#' + target}>{text}</a>
);

SkipToContentLink.propTypes = {
  text: PropTypes.string,
  target: PropTypes.string,
};

SkipToContentLink.defaultProps = {
  target: 'MainContent',
  text: 'Skip to main content',
};

export default SkipToContentLink;
